<div *ngIf="spin" class="d-flex justify-content-center"><app-spinner></app-spinner></div>
<div style="min-height: 550px">
  <nb-card>
    <nb-card-header>
      <h3 style="position: relative" i18n>Clean Score</h3>
    </nb-card-header>
    <nb-card-body>
      <div>
        <div class="row">
          <div>
            <h5 i18n>Robot ID:</h5>
          </div>
        </div>
        <!-- Robot selection -->
        <div class="row">
          <div class="col-9">
            <ng-select
              class="testisd"
              ngDefaultControl
              id="robot_id"
              name="robot_id"
              placeholder="Insert Robot IDs"
              i18n-placeholder
              multiple="true"
              [ngModelOptions]="{ standalone: true }"
              [(ngModel)]="selectedRobots"
              [addTag]="true"
              [selectOnTab]="true"
              [isOpen]="false"
              style="width: 68%"
              (add)="robotIdAdd($event)"
              (remove)="robotIdRemove($event)"
              (clear)="robotIdClear()"
            >
            </ng-select>
          </div>
        </div>
        <br />
        <div *ngIf="Object.keys(this.cleanScoreRecords).length > 0">
          <div *ngFor="let robot of loadedRobots">
            <div class="row">
              <h6 i18n>Select Pmap ID for {{ robot }}:</h6>
            </div>
            <ng-select
              fullWidth
              [(ngModel)]="selectedPmaps[robot]"
              [multiple]="true"
              placeholder="Select Pmap IDs"
              i18n-placeholder
            >
              <ng-option *ngFor="let p of Object.keys(this.cleanScoreRecords[robot])" [value]="p"> {{ p }} </ng-option>
            </ng-select>
            <br />
            <div *ngFor="let pmap of selectedPmaps[robot]">
              <div class="row">
                <p><strong i18n>Pmap ID: </strong>{{ pmap }}</p>
              </div>
              <div *ngFor="let region of this.cleanScoreRecords[robot][pmap].regions; let i = index">
                <div class="row">
                  <p style="text-indent: 15px">
                    <strong i18n>Region ID:</strong> {{ region.region_id }} - <strong i18n>Score:</strong>
                    {{ region.clean_score }}
                  </p>
                </div>
              </div>
            </div>
            <br />
            <hr />
          </div>
        </div>
        <br />
      </div>
    </nb-card-body>
  </nb-card>
</div>
